import Bullet from './src/Bullet'
import Button, { ButtonProps as bp } from './src/Button'
import Checkbox from './src/Checkbox'
import ErrorMessage from './src/Form/ErrorMessage'
import FormGroup from './src/Form/FormGroup'
import FormLabel from './src/Form/FormLabel'
import { Texts as t, TextProps as tp } from './src/Form/text-utils'
import Input, { InputProps as ip } from './src/Input'
import RadioButton, {
  RadioButtonHandle as rbh,
  RadioOption as ro,
  StyledRadio,
  StyledRadioGroup,
  RadioButtonProps as rbp,
  RadioBox
} from './src/RadioButton'
import TermsAndConditions from './src/TermsAndConditions'


export {
  Bullet,
  Button,
  Checkbox,
  ErrorMessage,
  FormGroup,
  FormLabel,
  Input,
  RadioButton,
  StyledRadio,
  StyledRadioGroup,
  RadioBox,
  TermsAndConditions
}

export type Texts = t
export type TextProps = tp
export type RadioButtonHandle = rbh
export type RadioOption = ro
export type RadioButtonProps = rbp
export type InputProps = ip
export type ButtonProps = bp

export interface Option {
  label: string
  value: string | number
  disabled?: boolean
}
